// Note: The first file of a module here, must also register the module

import "./ask-for-purchase.component";
import "./license-info-dialog.component";
import "./promo-code-dialog.component";
import "./purchase-seats-dialog.component";
